export const usmle1BiostatsModule = {
  id: "biostats",
  title: "Biostatistics",
  sections: [
    {
      type: "text",
      content:
        "Sensitivity = TP/(TP+FN). Specificity = TN/(TN+FP).",
    },
    {
      type: "question",
      text: "Which metric uses true positives and false negatives?",
      options: ["Specificity", "Sensitivity", "PPV", "NPV"],
      correct: 1,
      explanation: "Sensitivity = TP/(TP+FN).",
    },
  ],
};
